import HeroSection from "@/components/workshop-landing/HeroSection";
import ProgramCarousel from "@/components/workshop-landing/ProgramCarousel";
import ProfileTrainer from "@/components/workshop-landing/ProfileTrainer";
import ProcedureSteps from "@/components/common/procedure-steps/ProcedureSteps";
import RequirementsSection from "@/components/workshop-landing/RequirementSection";
import { WithDefaultLayout } from "@/components/DefautLayout";
import { Title } from '@/components/Title';
import { Page } from "@/types/Page";
import { procedure_steps } from "@/constants";

const BootcampPage: Page = () => {
  return (
    <div>
      <Title title={'Sertifikasi BNSP'} description='' />
      <div className="flex flex-col gap-10">
        <HeroSection />
        <ProgramCarousel />
        <ProfileTrainer />
        <RequirementsSection />
        <ProcedureSteps
          title="Prosedur Pendaftaran"
          subtitle=""
          steps={procedure_steps}
        />
      </div>
    </div>
  );
}

BootcampPage.layout = WithDefaultLayout;
export default BootcampPage;